import { render, staticRenderFns } from "./LeadEdit.vue?vue&type=template&id=c52f1906"
import script from "./LeadEdit.vue?vue&type=script&lang=js"
export * from "./LeadEdit.vue?vue&type=script&lang=js"
import style0 from "./LeadEdit.vue?vue&type=style&index=0&id=c52f1906&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports